// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { polyfill } from 'es6-promise'
import VueParticles from 'vue-particles'
import * as VueGoogleMaps from 'vue2-google-maps'
import VuetifyDraggableTreeview from 'vuetify-draggable-treeview'



polyfill()

import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import { store } from './store/store'
import 'vuetify/dist/vuetify.min.css'
import IdleVue from 'idle-vue'
import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)

Vue.use(Vuetify, { theme: {
  primary: '#f3aa32',
  secondary: '#4e474c',
  accent: '#f3aa32',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#e75869',
  customPurple: '#f3aa32',
  primary_blue:'#f3aa32',
  nav_background_color: '#4e474c',
  customVariables: ['~/assets/variables.scss'],
}})

Vue.use(VueParticles)

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 604800000 // 7 days
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBfjvF10C7dGFwRpGrqdx4PidsoXKmERP8',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  onIdle() {
    var url = window.location.href;
    var to = url.lastIndexOf('/') +1;
    window.location=url.substring(0,to);
    clearInterval(this.$store.state.intervalMap)
    location.reload()
  },
  onActive() {
    this.messageStr = 'Sesión Activa'
  }
},)

Vue.use(VuetifyDraggableTreeview)





// WEBPACK FOOTER //
// ./src/main.js